/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import utils from "@utils";
import { ClientService, ContactService } from "@services";
import InvoiceService from "@services/InvoiceService";
import { Modal } from "../../../../components";
import AddClientContactModal from "../../PaymentSummary/modals/AddClientContactModal";

const SendRemindersModal = ({
	show,
	onCancel,
	contactData,
	user,
	getContacts,
	clientId,
	invoiceId,
	billToEmail,
	billToName
}) => {
	const { lang } = global;
	const [clientEmailList, setClientEmailList] = useState({ isLoading: true, data: [] });
	const [ccList, setCCList] = useState([]);
	const [bccList, setBCCList] = useState("");
	const [bccError, setBccError] = useState(false);
	const [emailToMyself, setEmailToMyself] = useState(false);
	const [showAddContactModal, setShowAddClientModal] = useState(false);
	const [remindingClient, setRemindingClient] = useState(false);
	const [invoiceEmail, setInvoiceEmail] = useState("");
	const [invoiceName, setInvoiceName] = useState("");

	let newEmailList = "";

	const handleEmailToMyselfChange = e => {
		setEmailToMyself(e.target.checked);
	};

	const handleCCListChange = e => {
		setCCList(e);
	};

	const validateForm = bcc => {
		const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
		const splitedEmail = bcc.replace(/[\n\r\t]/gm, "").split(",");
		const uniqueEmails = new Set();

		splitedEmail.forEach(email => {
			const trimmedEmail = email.trim();

			if (!uniqueEmails.has(trimmedEmail)) {
				uniqueEmails.add(trimmedEmail);
			}
		});

		setBCCList([...uniqueEmails].join(","));
		newEmailList = [...uniqueEmails].join(",");

		return bcc !== ""
			? [...uniqueEmails].reduce((acc, email) => acc && emailRegex.test(email), true)
			: true;
	};

	const handleBCCListChange = e => {
		setBCCList(e.target.value);
	};

	const handleSend = () => {
		setRemindingClient(true);
		ClientService.sendPaymentReminder(clientId, {
			CC: ccList.length === 0 ? null : ccList.map(elm => elm.EmailAddress),
			BCC: newEmailList === "" ? null : newEmailList.split(",").map(email => email.trim()),
			SendEmailToMyself: emailToMyself,
			InvoiceId: invoiceId,
			BillToEmail: billToEmail ?? invoiceEmail,
			BillToName: billToName ?? invoiceName,
		})
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Reminder Sending Complete"),
					timeOut: 1500,
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error sending reminders"),
					timeOut: 1500,
				});
			})
			.finally(() => {
				setRemindingClient(false);
				setCCList([]);
				setBCCList("");
				setEmailToMyself(false);
				onCancel();
			});
	};

	const mapClientListItems = data => {
		const clientEmailListItems = data.ItemList.map(({ Id, ContactName, EmailAddress }) => ({
			value: Id,
			label: EmailAddress,
			EmailAddress,
			ContactName
		}));

		setClientEmailList({ isLoading: false, data: clientEmailListItems });
	};

	useEffect(() => {
		if (contactData && show) {
			mapClientListItems(contactData);
		}

		if(invoiceId && !billToEmail) {
			InvoiceService.getNonRKPayInvoice(invoiceId)
				.then(({ data }) => {
					if (data.ClientEmailAddress) {
						setInvoiceEmail(data.ClientEmailAddress);
					}
					if (data.ClientContactName) {
						setInvoiceName(data.ClientContactName);
					}
				})
				.catch(() => {
					utils.notify({
						type: "error",
						message: lang.t("Error loading client contacts"),
						timeOut: 1500,
					});
				});
		}
	}, [contactData, show]);

	useEffect(() => {
		if (!contactData && show) {
			ContactService.getAll({ clientId })
				.then(({ data }) => {
					mapClientListItems(data);
				})
				.catch(() => {
					utils.notify({
						type: "error",
						message: lang.t("Error loading client contacts"),
						timeOut: 1500,
					});
				});
		}
	}, [contactData, show]);

	const onApply = () => {
		const isValid = validateForm(bccList);
		const isBillingContactValid = (
			(
				invoiceEmail &&
				invoiceName &&
				invoiceEmail.length > 0
				&& invoiceName.length > 0
			) ||
			(
				billToEmail &&
				billToName &&
				billToEmail.length > 0 &&
				billToName.length > 0
			)
		);

		setBccError(!isValid);

		if (isValid && isBillingContactValid) {
			handleSend();
		}
	};

	const closeModal = () => {
		setCCList([]);
		setBCCList("");
		setEmailToMyself(false);
		setBccError(false);

		onCancel();
	};

	return (
		<>
			<Modal
				show={show}
				onHide={onCancel}
				id="send-recipients-for-all-modal"
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Send Reminder")}</Modal.Title>
				</Modal.Header>
				<Modal.Body id="send-recipients-for-all-modal">
					<div className="row form-group">
						<div className="col-xs-12">
							<p>
								{lang.t(
									"A reminder to pay this invoice will be sent to the contacts below",
								)}
								:{" "}
							</p>
						</div>
					</div>

					<div className="row form-group">
						<div className="col-xs-12">
							<label>{lang.t("To")}</label>
							<span className="required-mark" />
						</div>
						<div className="col-xs-12">{billToEmail ?? invoiceEmail}</div>
					</div>

					<div className="row form-group">
						<div className="col-xs-6">
							<label>{lang.t("CC")}:</label>
							<span className="required-mark" />
						</div>
						<div className="col-xs-6 text-right">
							<button
								type="button"
								id="open-add-client-modal"
								className="btn btn-link btn-blue-small"
								onClick={() => setShowAddClientModal(true)}
							>
								{`+ ${lang.t("Add new client contact")}`}
							</button>
						</div>
						<Select
							id="client-id"
							className="col-xs-12"
							name="clientId"
							options={clientEmailList.data}
							isLoading={clientEmailList.isLoading}
							value={ccList}
							onChange={handleCCListChange}
							isMulti
						/>
					</div>

					<div className="row form-group">
						<div className="col-xs-12">
							<small>
								{lang.t(
									"Need to send to additional people? Add emails below, separated by a comma",
								)}
							</small>
						</div>
						<div className="col-xs-12">
							<textarea
								className={`form-control ${bccError ? "error" : ""}`}
								placeholder={lang.t("BCC")}
								value={bccList}
								onChange={handleBCCListChange}
							/>
							{bccError && (
								<small className="text-danger">
									{lang.t(
										"The email format you’ve added is incorrect, please add an email with a valid format",
									)}
								</small>
							)}
						</div>
					</div>
					<div>
						<input
							type="checkbox"
							name="send-email-to-myself"
							checked={emailToMyself}
							onChange={handleEmailToMyselfChange}
						/>
						<small className="send-email-to-myself-label">
							{lang.t("Send an email to myself")}
						</small>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-default"
						onClick={closeModal}
					>
						{lang.t("Cancel")}
					</button>

					<button
						type="button"
						className="btn btn-primary"
						onClick={onApply}
						disabled={clientEmailList.isLoading }
					>
						<i
							className={`rkf rkf-spinner rkf-spin rkf-fw${remindingClient ? "" : " hidden"}`}
						/>
						<span className={remindingClient ? "hidden" : ""}>{lang.t("Send")}</span>
					</button>
				</Modal.Footer>
			</Modal>

			<AddClientContactModal
				show={showAddContactModal}
				user={user}
				clientId={clientId}
				organizationId={user.OrganizationId}
				onCancel={() => setShowAddClientModal(false)}
				onSave={() => {
					setShowAddClientModal(false);
					getContacts();
				}}
			/>
		</>
	);
};

SendRemindersModal.propTypes = {
	show: PropTypes.bool,
	onCancel: PropTypes.func,
	contactData: PropTypes.object,
	user: PropTypes.object,
	billToEmail: PropTypes.string,
	invoiceId: PropTypes.number,
};

SendRemindersModal.defaultProps = {
	show: false,
	onCancel: () => {},
	billToEmail: null,
	invoiceId: null,
};

export default SendRemindersModal;
